import React from 'react';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import Text from './Text';
import Map from './Map';
import LocationSearch from './LocationSearch';
import { useTranslation } from 'react-i18next';
import { DeliveryAddressSelected } from './DeliveryAddressSelected';
import getUserLocation from '../selectors/getUserLocation';
import { updateForm } from '../slices/deliveryAddressForm';
import AddressSearchInterface from './AddressSearchInterface';
import combineStyles from '../utils/combineStyles';

export const AddressLookupAndConfirmation = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const userLocation = useAppSelector(getUserLocation);
  const formState = useAppSelector(state => state.deliveryAddressForm);
  const markerPosition = formState.selectedAddress?.location || userLocation;

  const userLocationWithoutFallback = useAppSelector(state => state.currentUserLocation);
  const initialZoom = useAppSelector(state => state.config.initialZoom);
  let zoomLevel = !userLocationWithoutFallback ? initialZoom : undefined;

  if (formState.selectedAddress) {
    zoomLevel = undefined;
  }

  const onHandleAddressBarClick = () => {
    if (!formState.editingAddress) {
      dispatch(updateForm({ selectedAddress: undefined }));
    }
    dispatch(
      updateForm({
        addressInput: undefined,
        addressSelectionView: 'Lookup',
      }),
    );
  };

  const getMapHeight = () => {
    if (formState.adjustingPin) {
      return formState.modalHeight;
    }
    return formState.modalHeight * 0.75;
  };

  if (formState.addressSelectionView === 'Map') {
    return (
      <div style={styles.container}>
        <Map mapHeight={getMapHeight()} markerPosition={markerPosition} zoomLevel={zoomLevel} />
        {!formState.adjustingPin && (
          <div style={styles.bottomContainer}>
            {formState.selectedAddress ? (
              <DeliveryAddressSelected onClick={onHandleAddressBarClick} transparent />
            ) : (
              <div style={combineStyles(styles.locationSearchContainer)}>
                <Text variant="body" style={{ fontWeight: 500, fontSize: 16 }}>
                  {t('placeholder.whatsYourAddress')}
                </Text>
                <div className="location-search-pointer">
                  <LocationSearch
                    containerStyle={styles.locationSearch}
                    onClick={onHandleAddressBarClick}
                  />
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  if (formState.addressSelectionView === 'Lookup') {
    return (
      <div style={styles.lookupContainer}>
        <div style={styles.sideMargin}>
          <AddressSearchInterface />
        </div>
      </div>
    );
  }

  return null;
};

const styles: Styles = {
  sideMargin: {
    marginLeft: 16,
    marginRight: 16,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    width: '100%',
    height: '100%',
  },
  lookupContainer: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
  },
  bottomContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%',
    padding: 16,
  },
  locationSearchContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
};
